export const CATEGORIES = [
  { slug: "consumer-electronics", name: "Consumer Electronics", short: "Electronics", code: "01",
    image: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=1200&q=80",
    tagline: "Audio · Cameras · Tablets · TVs" },
  { slug: "automotive-accessories", name: "Automotive Accessories", short: "Automotive", code: "02",
    image: "https://images.unsplash.com/photo-1471174617910-3e9c04f58ff5?w=1200&q=80",
    tagline: "Dash cams · Floor liners · Cargo systems" },
  { slug: "home-improvement", name: "Home Improvement", short: "Home Improvement", code: "03",
    image: "https://images.unsplash.com/photo-1504148455328-c376907d081c?w=1200&q=80",
    tagline: "Power tools · Hand tools · Hardware" },
  { slug: "kitchen-appliances", name: "Kitchen Appliances", short: "Kitchen", code: "04",
    image: "https://images.unsplash.com/photo-1588854337115-1c67d9247e4d?w=1200&q=80",
    tagline: "Espresso · Mixers · Blenders" },
  { slug: "outdoor-equipment", name: "Outdoor Equipment", short: "Outdoor", code: "05",
    image: "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=1200&q=80",
    tagline: "Tents · Coolers · Backpacks" },
  { slug: "sporting-goods", name: "Sporting Goods", short: "Sporting", code: "06",
    image: "https://images.unsplash.com/photo-1485965120184-e220f721d03e?w=1200&q=80",
    tagline: "Cycling · Tennis · Fitness · Team sports" },
  { slug: "pet-products", name: "Pet Products", short: "Pet", code: "07",
    image: "https://images.unsplash.com/photo-1583337130417-3346a1be7dee?w=1200&q=80",
    tagline: "Cameras · Feeders · Toys · Crates" },
  { slug: "office-supplies", name: "Office Supplies", short: "Office", code: "08",
    image: "https://images.unsplash.com/photo-1580480055273-228ff5388ef8?w=1200&q=80",
    tagline: "Chairs · Peripherals · Printers" },
  { slug: "smart-home-devices", name: "Smart Home Devices", short: "Smart Home", code: "09",
    image: "https://images.unsplash.com/photo-1558002038-1055907df827?w=1200&q=80",
    tagline: "Hubs · Cameras · Lights · Thermostats" },
];

export const slugToName = Object.fromEntries(CATEGORIES.map((c) => [c.slug, c.name]));
